/**
 * The template list — the way into the authoring builder (R2, D21).
 *
 * Every stored version of every template. A report records the version it was rendered against,
 * so versions are first-class here: the list shows each, not just the latest, and a published
 * one is marked because it can be opened but not changed.
 */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { ApiError, templates, type TemplateRef } from '../lib/api';

export function TemplatesScreen() {
  const [rows, setRows] = React.useState<TemplateRef[] | null>(null);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    templates.list().then(setRows).catch((e) => setError(e instanceof ApiError ? e.message : String(e)));
  }, []);

  if (error) return <div className="banner error">{error}</div>;
  if (!rows) return <div className="busy">Loading templates…</div>;

  return (
    <div className="wide">
      <section className="table-block wide">
        <header className="table-head"><h2>Templates</h2></header>
        <p className="sub" style={{ padding: '0 14px' }}>
          The documents reports are rendered from. A <strong>published</strong> version is
          immutable — open it to review, but edits fork a new version.
        </p>
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Name</th><th>Version</th><th>Status</th><th>Channels</th>
                <th>Updated</th><th>By</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={`${t.id}:${t.version}`}>
                  <td>
                    <Link to={`/templates/${encodeURIComponent(t.id)}/${t.version}`}>{t.name}</Link>
                    <div className="muted"><code>{t.id}</code></div>
                  </td>
                  <td className="num">v{t.version}</td>
                  <td>
                    <span className={`pill ${t.status === 'published' ? 'ok' : t.status === 'archived' ? 'off' : ''}`}>
                      {t.status}
                    </span>
                  </td>
                  <td>{t.channels.join(', ')}</td>
                  <td>{t.updatedAt.slice(0, 10)}</td>
                  <td className="muted">{t.updatedBy}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={6} className="empty">No templates stored. Run <code>seed:templates</code>.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
